import { addListener, asyncThunkCreator, buildCreateSlice, createListenerMiddleware, UnknownAction } from "@reduxjs/toolkit";

import { AppDispatch, RootState } from "./hooks";
import { ExtraOptions } from "./http/types";

// Helper para extrair meta.arg de uma ação RTK Query
function extractRTKQueryMeta(action: UnknownAction) {
  if (action.meta && typeof action.meta === "object" && "arg" in action.meta) {
    const arg = action.meta.arg as Record<string, unknown>;
    return {
      endpointName: arg.endpointName as string | undefined,
      forceRefetch: arg.forceRefetch as boolean | undefined,
      subscribe: arg.subscribe as boolean | undefined,
      originalArgs: arg.originalArgs
    };
  }
  return null;
}

const createAppSlice = buildCreateSlice({
  creators: {
    asyncThunk: asyncThunkCreator
  }
});

const listenerMiddleware = createListenerMiddleware({
  onError: console.error
});
const startAppListening = listenerMiddleware.startListening.withTypes<RootState, AppDispatch, ExtraOptions>();
const stopAppListening = listenerMiddleware.stopListening.withTypes<RootState, AppDispatch, ExtraOptions>();
const addAppListener = addListener.withTypes<RootState, AppDispatch, ExtraOptions>();

export { addAppListener, createAppSlice, extractRTKQueryMeta, listenerMiddleware, startAppListening, stopAppListening };
